import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

import { camelToSnake, snakeToCamel } from "caseparser";

export const productsApi = api
  .enhanceEndpoints({ addTagTypes: ["carts", "categories"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      createCart: builder.mutation({
        query: ({ branchId, userId, productId, amount }) => ({
          url: `branchs/${branchId}/carts`,
          method: RequestMethod.POST,
          body: camelToSnake({
            userId,
            productId,
            amount,
          }),
        }),
        invalidatesTags: ["carts"],
      }),
      updateCart: builder.mutation({
        query: ({ branchId, id, userId, productId, amount, price }) => ({
          url: `branchs/${branchId}/carts/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            userId,
            productId,
            amount,
            price,
          }),
        }),
        invalidatesTags: ["carts"],
      }),
      deleteCart: builder.mutation({
        query: ({ branchId, id, userId }) => ({
          url: `branchs/${branchId}/carts/${id}`,
          method: RequestMethod.DELETE,
          body: camelToSnake({
            userId,
          }),
        }),
        invalidatesTags: ["carts"],
      }),
      carts: builder.query({
        query: ({ branchId, userId }) => ({
          url: `branchs/${branchId}/carts`,
          method: RequestMethod.GET,
          params: camelToSnake({
            userId,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["carts"],
      }),
    }),
  });

export const {
  useCartsQuery,
  useCreateCartMutation,
  useUpdateCartMutation,
  useDeleteCartMutation,
} = productsApi;
